
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post",
      function () {
        return require("private-next-pages/post.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post"])
      });
    }
  